export const REFRESH_TOKEN_LIFETIME = 10000;

export const HTTP_STATUS = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
};
